import {useTheme} from "../../UI/Theme/ThemeContext";
import {ButtonActionStyled, EduCardStyled} from "../../../styled/Resume";
import InputHandler from "./InputHandler";
import {MdDelete} from "react-icons/md";
import {FaPlus} from "react-icons/fa6";
import React from "react";


const CertificationCard = (props)=> {
    const {
        awardArray,
        handleAwardChange,
        handleDeleteAward,
        handleAddAward,

    } = props;

    const {themeName} = useTheme();

    return (
        <div className="eduContainer">
            {
                awardArray.map((info, index) => (
                    <EduCardStyled key={index} theme={themeName}>
                        <div className="inputs">
                            <InputHandler
                                name="org"
                                id={info.org + index}
                                value={info.org}
                                type="text"
                                label="Awarding Organization"
                                required={true}
                                onChange={(event) => handleAwardChange(event, index)}
                            />
                            <InputHandler
                                name="award"
                                id={info.award + index}
                                value={info.award}
                                type="text"
                                label="Award Received"
                                required={true}
                                onChange={(event) => handleAwardChange(event, index)}
                            />
                            <InputHandler
                                name="date"
                                id={info.date + index}
                                value={info.date}
                                type="date"
                                label="Date Awarded"
                                required={true}
                                onChange={(event) => handleAwardChange(event, index)}
                            />
                        </div>
                        <ButtonActionStyled>
                            <span className="del" onClick={handleDeleteAward}> <MdDelete/> </span>
                            <span className="add" onClick={handleAddAward}> <FaPlus/> </span>
                        </ButtonActionStyled>

                    </EduCardStyled>

                ))
            }

        </div>
    )
}

export default CertificationCard;